import {ElMessage} from 'element-plus';

/**
 * 统一处理API请求错误并显示提示
 * @param error 错误对象
 * @param defaultMessage 默认提示消息
 */
export function handleApiError(error: any, defaultMessage: string = '操作失败，请稍后重试') {
    const apiMessage = error?.response?.data?.message ?? error?.message;

    const errorMessage = apiMessage
        ? `${apiMessage}`
        : defaultMessage;

    ElMessage.error(errorMessage);
}
